const SESSION_KEY = 'commission_dashboard.session';
const REMEMBERED_TOKEN_KEY = 'commission_dashboard.remembered_token';

const readStorage = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn(`Unable to read ${key} from localStorage:`, error);
    return null;
  }
};

const writeStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.warn(`Unable to store ${key}:`, error);
  }
};

const removeStorage = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn(`Unable to remove ${key}:`, error);
  }
};

const parseJson = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

/** Session shape: { token } — token-only auth, nothing else to track. */
export const getSession = () => parseJson(readStorage(SESSION_KEY));

export const saveSession = (nextSession) => {
  const session = { ...(getSession() || {}), ...nextSession };

  if (!session.token) {
    clearSession();
    return null;
  }

  writeStorage(SESSION_KEY, JSON.stringify(session));
  return session;
};

export const clearSession = () => removeStorage(SESSION_KEY);

// Remembered token survives session clears so login is pre-filled.
export const saveRememberedToken = (token) => {
  if (token) writeStorage(REMEMBERED_TOKEN_KEY, token);
  else removeStorage(REMEMBERED_TOKEN_KEY);
};

export const getRememberedToken = () => readStorage(REMEMBERED_TOKEN_KEY) || '';
